import { ButtonClassType } from '../../../../enums/buttons';
import Color from '../../../../enums/color';
import { getSimplifiedColorCode } from '../../../../helpers/color';
const primaryButtonStyle = `
  &.kpmg-button-${ButtonClassType.Primary} {
    box-shadow: 0 3px 3px 0 ${Color.BlackOpacity30};
    
    &.disabled {
      box-shadow: none;
      background: ${Color.Grey187};
      cursor: default;
    }
    
    &.colorTheme-${getSimplifiedColorCode(Color.Apple)} {
      background: ${Color.Apple};
      
      &:hover {
        background: ${Color.Atlantis};
      }
      
      &:active {
        background: ${Color.ForestGreen};
        box-shadow: unset;
      }
    }
    
    &.colorTheme-${getSimplifiedColorCode(Color.FlushOrange)} {
      background: ${Color.FlushOrange};
      
      &:hover {
        background: ${Color.Koromiko};
      }
      
      &:active {
        background: ${Color.RedStage};
        box-shadow: unset;
      }
    }

		&.colorTheme-${getSimplifiedColorCode(Color.DarkSkyBlue)} {
      background: ${Color.DarkSkyBlue};
      
      &:hover {
        background: ${Color.DarkSkyBlueOpacity80};
      }
      
      &:active {
        background: ${Color.FunBlue};
        box-shadow: unset;
      }
    }

		&.colorTheme-${getSimplifiedColorCode(Color.DarkCyanBlue)} {
      background: ${Color.DarkCyanBlue};
      
      &:hover {
        background: ${Color.DarkCyanBlueOpacity80};
      }
      
      &:active {
        background: ${Color.DeepCerulian};
        box-shadow: unset;
      }
    }

		&.colorTheme-${getSimplifiedColorCode(Color.Rose)} {
      background: ${Color.Rose};
      
      &:hover {
        background: ${Color.RoseOpacity80};
      }
      
      &:active {
        background: ${Color.Shiraz};
        box-shadow: unset;
      }
    }

		&.colorTheme-${getSimplifiedColorCode(Color.White)} {
      background: ${Color.White};
      color: ${Color.MicrosoftBlue};

      &:hover {
        background: ${Color.MicrosoftBlueOpacity8};
      }
      
      &:active {
        background: ${Color.MicrosoftBlueOpacity8};
        box-shadow: unset;
      }
    }

    &.colorTheme-${getSimplifiedColorCode(Color.MicrosoftBlue)} {
      background: ${Color.MicrosoftBlue};
      color: ${Color.White};

      &:hover: {
        background: ${Color.MicrosoftBlueOpacity8}
      }

      &:active {
        background: ${Color.MicrosoftBlueOpacity8};
        box-shadow: unset;
      }
    }

    &.colorTheme-${getSimplifiedColorCode(Color.DodgerBlue)} {
      background: ${Color.DodgerBlue};
      
      &:hover {
        background: ${Color.DodgerBlueOpacity80};
      }
      
      &:active {
        background: ${Color.MicrosoftBlue};
        box-shadow: unset;
      }
    }
    
    &.colorTheme-${getSimplifiedColorCode(Color.MaroonFlush)} {
      background: ${Color.MaroonFlush};
      
      &:hover {
        background: ${Color.MaroonFlushOpacity80};
      }
      
      &:active {
        background: ${Color.Claret};
        box-shadow: unset;
      }
    }

    &.colorTheme-${getSimplifiedColorCode(Color.Smalt)} {
      background: ${Color.Smalt};
      
      &:hover {
        background: ${Color.SmaltOpacity80};
      }
      
      &:active {
        background: ${Color.MidnightBlue};
        box-shadow: unset;
      }
    }
    
    &.colorTheme-${getSimplifiedColorCode(Color.GreenHaze)} {
      background: ${Color.GreenHaze};
      
      &:hover {
        background: ${Color.GreenHazeOpacity80};
      }
      
      &:active {
        background: ${Color.FunGreen};
        box-shadow: unset;
      }
    }

    &.colorTheme-${getSimplifiedColorCode(Color.WebOrange)} {
      background: ${Color.WebOrange};
      
      &:hover {
        background: ${Color.WebOrangeOpacity80};
      }
      
      &:active {
        background: ${Color.PirateGold};
        box-shadow: unset;
      }
    }
    
    &.colorTheme-${getSimplifiedColorCode(Color.ChelseaGem)} {
      background: ${Color.ChelseaGem};
      
      &:hover {
        background: ${Color.ChelseaGemOpacity80};
      }
      
      &:active {
        background: ${Color.Cinnamon};
        box-shadow: unset;
      }
    }
    
    &.colorTheme-${getSimplifiedColorCode(Color.Red)} {
      background: ${Color.Red};
      
      &:hover {
        background: ${Color.RedOpacity80};
      }
      
      &:active {
        background: ${Color.GuardsmanRed};
        box-shadow: unset;
      }
    }

    &.colorTheme-${getSimplifiedColorCode(Color.Seance)} {
      background: ${Color.Seance};
      
      &:hover {
        background: ${Color.SeanceOpacity80};
      }
      
      &:active {
        background: ${Color.ChinesePurple};
        box-shadow: unset;
      }
    }

    &.colorTheme-${getSimplifiedColorCode(Color.CuriousBlue)} {
      background: ${Color.CuriousBlue};
      
      &:hover {
        background: ${Color.CuriousBlueOpacity80};
      }
      
      &:active {
        background: ${Color.DeepSeaGreen};
        box-shadow: unset;
      }
    }
  }
`;
export default primaryButtonStyle;
